import { render, staticRenderFns } from "./ProcessCreateComprehensiveSignCustomer.vue?vue&type=template&id=25f671dc"
import script from "./ProcessCreateComprehensiveSignCustomer.vue?vue&type=script&lang=js"
export * from "./ProcessCreateComprehensiveSignCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports